import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import server from '../../../_api/backend';
import * as toast from '../../../_store/slice/toast';

type Params = {
  id: string;
  ctgy: string;
};

export function AdminReplyView(routeProps: any) {
  const { match, location } = routeProps;
  const { id, ctgy } = match.params as Params;
  const [reply, setReply] = useState<any>();
  const [add, setAdd] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();

  // 주소창 강제이동 또는 관리자 권한이 없는 사용자 → 메인페이지 이동
  useEffect(() => {
    if (
      window.localStorage.getItem('token') === null ||
      window.localStorage.getItem('authority') !== 'A'
    ) {
      dispatch(toast.error({ message: '관리자 권한이 없습니다.' }));
      history.push('/');
    }
  }, []);

  useEffect(() => {
    server.getReplyId(id).then((payload) => {
      if (!payload) {
        dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
      } else if (payload.code === 260 || payload.code === 500) {
        dispatch(toast.error({ message: '파라미터 오류' }));
      } else {
        setReply(payload);
      }
    });
  }, []);

  const attachFile = (fileList: string[]) => {
    return fileList.map((fileName) => {
      if (fileName.length === 0) return <></>;

      return (
        <li>
          <button className="btn-file" type="button">
            {fileName}
          </button>
        </li>
      );
    });
  };

  const getDeleteButton = () => {
    if (window.confirm('정말 삭제하시겠습니까?')) {
      server.deleteReply(ctgy, id).then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        } else {
          routeProps.history.goBack();
        }
      });
    }
  };

  return (
    <main className="sub wrapper board-view">
      <div className="content">
        <div className="title">
          <h1>{ctgy === 'notice' ? '공지사항' : ''}</h1>
          <h1>{ctgy === 'errata' ? '정오표' : ''}</h1>
          <h1>{ctgy === 'lecture-lib' ? '강의 자료실' : ''}</h1>
          <h1>{ctgy === 'lib' ? '일반 자료실' : ''}</h1>
          <h1>{ctgy === 'qna' ? '질의응답' : ''}</h1>
        </div>

        <div className="view-content">
          <div className="view-header">
            <div className="view-title">{reply?.subject}</div>
            <div className="writer">{reply?.writer?.name}</div>
            <ul>
              <li className="date">{new Date(reply?.modDate).toLocaleDateString()}</li>
              <li className="views">{reply?.hit}</li>
            </ul>
            {/* <ul className="files">
              <li>
                <svg
                  className="ico-file"
                  xmlns="http://www.w3.org/2000/svg"
                  height="18"
                  viewBox="0 0 24 24"
                  width="18"
                >
                  <path d="M0 0h24v24H0z" fill="none" />
                  <path d="M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z" />
                </svg>
                <span>첨부파일:</span>
              </li>
              <li>
                <button className="btn-file" type="button">
                  file_01.pdf
                </button>
              </li>
            </ul> */}
          </div>
          <div className="description">
            <pre>{reply?.content}</pre>
          </div>
        </div>

        <div className="view-footer">
          <button
            className="btn-sub"
            type="button"
            onClick={() => {
              routeProps.history.goBack();
            }}
          >
            목록
          </button>
          <button
            className="btn-sub"
            type="button"
            onClick={() => {
              getDeleteButton();
            }}
          >
            삭제
          </button>
          <button
            className="btn-sub"
            type="button"
            onClick={() => {
              routeProps.history.push({
                pathname: `/admin/board/adminReplyWrite/${ctgy}/${id}`,
                state: { replyAdd: add },
              });
            }}
          >
            수정
          </button>
        </div>
      </div>
    </main>
  );
}
